import { render, staticRenderFns } from "./SingularityImageMediaPreview.vue?vue&type=template&id=79a24880&"
import script from "./SingularityImageMediaPreview.vue?vue&type=script&lang=ts&"
export * from "./SingularityImageMediaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityImageMediaPreview.vue?vue&type=style&index=0&id=79a24880&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports